import { useCallback, useEffect, useState } from 'react'
import { useCopyToClipboard } from 'react-use';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { FormInput, FormInputLabel, useForm } from '@hilma/netina2all';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import clsx from 'clsx';

import { useI18n } from '../hooks';

import { useStyles as useFreeSaleStyles } from '../routes/Profile/StationManagement/FreeSale';

interface DesignatedPurchaseLinkProps {
	link: string | undefined;
	marginBottom?: boolean;
	hideLabel?: boolean;
	isStation?: boolean;
}

const DesignatedPurchaseLink: React.FC<DesignatedPurchaseLinkProps> = ({ link, marginBottom, hideLabel = false, isStation }) => {

	const classes = useStyles();
	const [, copyToClipboard] = useCopyToClipboard();
	const [tooltipOpen, setTooltipOpen] = useState(false);

	const form = useForm();
	const isMobile = useMediaQuery('(max-width: 800px)');
	const freeSaleClasses = useFreeSaleStyles();


	const linkText = useI18n(i => i.am.purchaseLink);
	const linkTooltipText = useI18n(i => isStation ? i.sm.additionalDetails.linkTooltip : i.am.linkTooltip);
	const copied = useI18n(i18n => i18n.freeSale.copied);
	const copy = useI18n(i18n => i18n.freeSale.copy);

	const copyLinkToClipboard = useCallback(() => {
		if (!link) return;
		copyToClipboard(link);
		setTooltipOpen(true);
	}, [link, copyToClipboard]);


	useEffect(() => {
		if (!tooltipOpen) return;

		const timeoutId = setTimeout(() => {
			setTooltipOpen(false);
		}, 2000);

		return () => {
			clearTimeout(timeoutId);
		}
	}, [tooltipOpen]);

	useEffect(() => {
		form.setFieldValue('link', link);
	}, [link]);

	return (
		<div className={clsx(marginBottom && classes.marginBottom)}>
			<div className={classes.inputContainer}>
				{!hideLabel && <FormInputLabel classes={{ labelContainer: classes.labelText, label: classes.font }} id='link' description={`${linkText}:`} tooltip={linkTooltipText} />}
				{!isMobile ? <FormInput
					onClick={copyLinkToClipboard}
					id="link"
					description={""}
					readOnly
					onBlur={() => { }}
					classes={{
						errorContainer: classes.errorContainer,
						root: classes.stuff,
						labelContainer: classes.label,
						container: classes.input,
						input: classes.theInput
					}}
					dir="ltr"
				/> : <div
					onClick={copyLinkToClipboard}
					className={classes.link}
				>
					{link}
				</div>
				}

				<div>
					<Tooltip
						PopperProps={{
							disablePortal: true,
						}}
						open={tooltipOpen}
						disableFocusListener
						disableHoverListener
						disableTouchListener
						title={copied}
						classes={{
							tooltip: classes.tooltip,
							popper: classes.tooltip
						}}
					>
						<Button
							color="primary"
							onClick={copyLinkToClipboard}
							classes={{
								root: clsx(freeSaleClasses.button, classes.outline),
								label: classes.buttonLabel
							}}
						>
							{copy}
						</Button>
					</Tooltip>
				</div>
			</div>
		</div>
	)
}

export default DesignatedPurchaseLink;


const useStyles = makeStyles(theme => ({
	stuff: {
		marginTop: 10,
		fontSize: '16px !important',
		height: '32px',
		width: '25vw',
		alignItems: 'center',
		justifyContent: 'center',
		[theme.breakpoints.down(800)]: {
			fontSize: 'calc((10vw + 18px) / 3.1) !important'
		}
	},
	label: {
		minWidth: '0px !important',
	},
	container: {
		width: '25vw',
		[theme.breakpoints.down(800)]: {
			width: 'unset'
		}
	},
	inputContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		[theme.breakpoints.down(800)]: {
			alignItems: 'flex-start',
			flexWrap: 'wrap'
		}
	},
	input: {
		width: '25vw',
		minWidth: '0 !important',
		[theme.breakpoints.down(800)]: {
			width: 'unset'
		}
	},
	errorContainer: {
		width: '0vw !important',
		minWidth: '0vw !important'
	},
	theInput: {
		fontSize: 17.5,
		fontFamily: 'Assistant-Regular',
		color: theme.palette.primary.main,
		textAlign: 'right',
		[theme.breakpoints.up(1600)]: {
			fontSize: '20px !important',
		}
	},
	tooltip: {
		width: 'fit-content !important',
		minWidth: 'unset !important'
	},
	buttonLabel: {
		fontSize: 16.5,
		textTransform: 'none',
		fontFamily: 'Assistant-SemiBold !important',
		[theme.breakpoints.up(1600)]: {
			fontSize: 20,
		}
	},
	link: {
		fontFamily: 'Assistant-Regular !important',
		direction: 'rtl',
		width: '85vw',
		overflowAnchor: 'none',
		overflowX: 'scroll',
		whiteSpace: 'nowrap',
		color: theme.palette.primary.main,
	},
	outline: {
		[theme.breakpoints.down(800)]: {
			border: `1px solid ${theme.palette.primary.main}`
		}
	},
	labelText: {
		fontFamily: 'Assistant-SemiBold',
		color: theme.palette.primary.main,
		textAlign: 'right',
		paddingRight: '10px',
		[theme.breakpoints.up(1600)]: {
			fontSize: '18px !important',
		}
	},
	font: {
		fontSize: 23
	},
	marginBottom: {
		marginBottom: 50
	}
}));
